import { useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export function UserProfileModal({ onClose }: { onClose: () => void }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [status, setStatus] = useState<{ type: 'error' | 'success', msg: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!oldPassword || !newPassword) return;
    
    try {
      await api.changePassword(oldPassword, newPassword);
      setStatus({ type: 'success', msg: 'Password updated successfully!' });
      setOldPassword('');
      setNewPassword('');
    } catch (err: any) {
      setStatus({ type: 'error', msg: err.message });
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999
    }}>
      <div className="card" style={{ width: '400px', position: 'relative' }}>
        <button 
          onClick={onClose} 
          style={{ position: 'absolute', top: '12px', right: '12px', background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '18px' }}
        >
          ×
        </button>
        
        <h2 style={{ fontSize: '18px', marginBottom: '8px' }}>User Profile</h2>
        <div style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '24px' }}>
          Welcome back, <strong style={{ color: 'var(--text-primary)' }}>{user?.username}</strong>!
        </div>


        <h3 style={{ fontSize: '14px', marginBottom: '16px' }}>Change Password</h3>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>Old Password</label>
            <input 
              type="password" 
              className="input" 
              style={{ width: '100%' }}
              value={oldPassword} 
              onChange={e => setOldPassword(e.target.value)} 
              required 
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>New Password</label>
            <input 
              type="password" 
              className="input" 
              style={{ width: '100%' }}
              value={newPassword} 
              onChange={e => setNewPassword(e.target.value)} 
              required 
              minLength={6}
            />
          </div>

          {status && (
            <div style={{ 
              padding: '8px 12px', 
              borderRadius: '4px', 
              fontSize: '12px',
              background: status.type === 'error' ? 'rgba(239,68,68,0.1)' : 'rgba(16,185,129,0.1)',
              color: status.type === 'error' ? '#ef4444' : '#10b981'
            }}>
              {status.msg}
            </div>
          )}

          <div style={{ marginTop: '8px' }}>
            <button type="submit" className="btn btn--primary" style={{ width: '100%' }}>Update Password</button>
          </div>
        </form>
      </div>
    </div>
  );
}
